import React, { useState } from 'react';
import { FaWhatsapp, FaPhone, FaTimes, FaMailBulk, FaComments } from 'react-icons/fa';
import logo from '../images/logo.png';

const WhatsAppChatInterface = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showChatPage, setShowChatPage] = useState(false);
    const [showMailPage, setShowMailPage] = useState(false);

    const phoneNumber = '+918333880649'; 
    const whatsappURL = `https://wa.me/${phoneNumber}`;
    const callURL = `tel:${phoneNumber}`; 
    const mailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=olewintechsolutions@gmail.com&su=Inquiry&body=Hello%20Olewin%20Tech%20Team`;

    const handleWhatsAppClick = (e) => {
        e.preventDefault();
        setShowChatPage(true);
    };
    const closeChatPage = () => {
        setShowChatPage(false);
    };
    const continueToChat = () => {
        window.open(whatsappURL, '_blank');
        setShowChatPage(false);
    };

    // mail page model getFunctions
    const handleMailPageClick = (e) => {
        e.preventDefault();
        setShowMailPage(true);
    };
    const closeMailPage = () => {
        setShowMailPage(false);
    };
    const continueToMail = () => {
        window.open(mailURL, '_blank');
        setShowMailPage(false);
    };

    return (
        <>
            {/* WhatsApp Chat Page Modal */}
            {showChatPage && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <button style={styles.closeButton} onClick={closeChatPage}>
                            <FaTimes size={20} />
                        </button>
                        
                        {/* Academy Logo */}
                        <div style={styles.logoContainer}>
                            {/* Replace with your actual logo image */}
                            {/* Tech Logo */}
                            <div style={styles.logoContainer}>
                                {/* Replace the URL with your actual logo URL */}
                                <img 
                                    src={logo}
                                    alt="olewin Tech" 
                                    style={{
                                        width: '250px',
                                        height: 'auto',
                                        borderRadius: '8px',
                                        objectFit: 'contain'
                                    }} 
                                />
                            </div>                           
                        </div>               
                        <h1 style={styles.chatTitle}>Connect on WhatsApp</h1>                       
                        <p style={styles.description}>
                            Connect with our Expert Business Advisor (or) Tech Representatives to get more information 
                            about our Services we offer.
                        </p>
                        
                        <button style={styles.continueButton} onClick={continueToChat}>
                            Continue to Chat
                        </button>
                    </div>
                </div>
            )}
            
            {/* Mail Page Modal */}
            {showMailPage && (
                <div style={styles.modalOverlay}>
                    <div style={styles.modalContent}>
                        <button style={styles.closeButton} onClick={closeMailPage}>
                            <FaTimes size={20} />
                        </button>
                        
                        {/* Academy Logo */}
                        <div style={styles.logoContainer}>
                            {/* Replace with your actual logo image */}
                            {/* Tech Logo */}
                            <div style={styles.logoContainer}>
                                {/* Replace the URL with your actual logo URL */}
                                <img 
                                    src={logo}
                                    alt="olewin Tech" 
                                    style={{
                                        width: '250px',
                                        height: 'auto',
                                        borderRadius: '8px',
                                        objectFit: 'contain'
                                    }} 
                                />
                            </div>
                        </div>
                        
                        <h1 style={styles.chatTitle}>Continue to Email/GMail to Send a Request Mail</h1>
                        
                        <p style={styles.description}>
                            Connect with our Expert Business Advisor (or) Tech Representatives to get more information 
                            about our Services we offer.
                        </p>
                        
                        <button style={styles.mailButton} onClick={continueToMail}>
                            Continue to Mail
                        </button>
                    </div>
                </div>
            )}

            {/* Floating Button Container */}
            <div style={styles.container}>
                {/* Expanded Options */}
                {isOpen && (
                    <div style={styles.options}>
                        {/* Mail Button */}
                        <a 
                            href={mailURL} 
                            onClick={handleMailPageClick}
                            style={{...styles.optionButton, backgroundColor: '#000000'}}
                        >
                            <FaMailBulk size={24} color="white" />
                        </a>

                        {/* WhatsApp Button */}
                        <a 
                            href={whatsappURL} 
                            onClick={handleWhatsAppClick}
                            style={{...styles.optionButton, backgroundColor: '#25D366'}}
                        >
                            <FaWhatsapp size={24} color="white" />
                        </a>

                        {/* Call Button */}
                        <a 
                            href={callURL} 
                            style={styles.optionButton}
                        >
                            <FaPhone size={24} color="white" />
                        </a>
                    </div>
                )}

                {/* Main Floating Button */}
                <button 
                    style={styles.chatButton} 
                    onClick={() => setIsOpen(!isOpen)}
                    aria-label={isOpen ? "Close contact options" : "Open contact options"}
                >
                    {isOpen ? (
                        <FaTimes size={38} />
                    ) : (
                        <FaComments size={30} />
                    )}
                </button>
            </div>
        </>
    );
};

// Styles
const styles = {
    container: {
        position: 'fixed',
        bottom: '100px',
        right: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 999,
    },
    chatButton: {
        backgroundColor: '#21D306',
        color: 'white',
        border: 'none',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.5)',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    options: {
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        marginBottom: '15px',
        animation: 'fadeIn 0.3s ease-out',
    },
    optionButton: {
        backgroundColor: '#008AFF',
        color: 'white',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '30px',
        maxWidth: '500px',
        width: '90%',
        position: 'relative',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
    },
    closeButton: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#777',
        padding: '5px',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
    },
    logo: {
        width: '80px',
        height: '80px',
        backgroundColor: '#4CADF10',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '36px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    academyName: {
        margin: '0',
        color: '#333',
        fontSize: '24px',
    },
    chatTitle: {
        fontSize: '24px',
        marginBottom: '20px',
        color: '#333',
        fontWeight: 'normal',
    },
    description: {
        color: '#666',
        marginBottom: '30px',
        lineHeight: '1.5',
    },
    continueButton: {
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '50px',
        padding: '15px 30px',
        fontSize: '18px',
        cursor: 'pointer',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        transition: 'all 0.3s ease',
    },
    mailButton: {
        backgroundColor: '#000000',
        color: 'white',
        border: 'none',
        borderRadius: '50px',
        padding: '15px 30px',
        fontSize: '18px',
        cursor: 'pointer',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        transition: 'all 0.3s ease',
    },
};

// Add CSS animation
const styleElement = document.createElement('style');
styleElement.innerHTML = `
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
`;
document.head.appendChild(styleElement);

export default WhatsAppChatInterface;